<div class="d-flex justify-content-between align-items-center w-100">

  <div class="d-flex align-items-center gap-3">
    <app-page-header Heading="SMS Template" Description="">
    </app-page-header>

    <app-pagination [EnablePageSize]="true" [rowData]="smsTemplateList"
      (pageSizeChanged)="handlePageSizeChange($event)">
    </app-pagination>
  </div>

  <div class="d-flex align-items-center">
    <button class="btn btn-sm btn-primary shadow-sm" (click)="openSmsTemplateForm()" [disabled]="isLoading || isSubmitting">
      <i class="bi bi-file-earmark-plus me-1"></i> Add New SMS Template
    </button>
  </div>

</div>

<app-color-table [columns]="[
    { colName: 'Template Name', colData: 'tName' },
    { colName: 'Description', colData: 'tDesc' },
    { colName: 'Data', colData: 'templateData' },
    { colName: 'Variable', colData: 'templateVariable' },
    { colName: 'Created At', colData: 'templateCreatedDate' },
    { colName: 'Approved At', colData: 'templateApprovedDate' }
  ]" [tableData]="this.smsTemplateList" [enableActionColumn]="true" [actionColumnLabel]="'Action'" [actionOptions]="[
    { actionName: 'Edit', actionIcon: 'fa fa-edit' },
    { actionName: 'Delete', actionIcon: 'fa fa-trash' }
  ]" (actionClick)="handleActionClick($event)" [DataLoading]="isLoading">
  ></app-color-table>
<app-pagination [EnableNavigation]="true" [rowData]="smsTemplateList" (pageSizeChanged)="handlePageSizeChange($event)">
</app-pagination>
<ng-template #smsTemplateModalForm>
  <div class="modal-header">
    <h5 class="modal-title">New SMS Configuration</h5>
    <button type="button" class="btn-close btn-close-white" (click)="addsmsTemplateModalContent.close()"></button>
  </div>

  <div class="modal-body">
    <form [formGroup]="smsTemplateForm">
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label for="tName">Template Name <span style="color: red">*</span></label>
            <input type="text" class="form-control form-control-sm" [formControl]="smsTemplateForm.controls.tName"
              placeholder="Name" />
            <app-form-errors [control]="smsTemplateForm.controls.tName"></app-form-errors>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label for="tName">Template Data <span style="color: red">*</span></label>
            <input type="text" class="form-control form-control-sm"
              [formControl]="smsTemplateForm.controls.templateData" placeholder="" />
            <app-form-errors [control]="smsTemplateForm.controls.templateData"></app-form-errors>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label for="tName">Template Variable <span style="color: red">*</span></label>
            <input type="text" class="form-control form-control-sm"
              [formControl]="smsTemplateForm.controls.templateVariable" placeholder="" />
            <app-form-errors [control]="smsTemplateForm.controls.templateVariable"></app-form-errors>
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-md-6">
          <div class="form-group">
            <label for="channel">Template Created Date</label>
            <input type="date" class="form-control form-control-sm"
              [formControl]="smsTemplateForm.controls.templateCreatedDate" placeholder="" />
            <app-form-errors [control]="smsTemplateForm.controls.templateCreatedDate"></app-form-errors>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label for="senderId">Template Approved Date</label>
            <input type="date" class="form-control form-control-sm"
              [formControl]="smsTemplateForm.controls.templateApprovedDate" placeholder="" />
          </div>
        </div>
      </div>

      <div class="row mt-2">
        <div class="col-md-12">
          <div class="form-group">
            <label for="cDesc">Template Description</label>
            <textarea class="form-control form-control-sm" [formControl]="smsTemplateForm.controls.tDesc"
              placeholder="Description"></textarea>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="modal-footer mt-1">
    <button type="button" class="btn btn-primary" (click)="submitSmsTemplateForm()" [disabled]="isSubmitting">
      <ng-container *ngIf="!isSubmitting">Submit</ng-container>
      <ng-container *ngIf="isSubmitting">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        Submitting...
      </ng-container>
    </button>
    <button type="button" class="btn btn-secondary" (click)="addsmsTemplateModalContent.close()">
      Close
    </button>
  </div>
</ng-template>